import { StarDecoration } from "../star-decoration"

export function StarsMobile() {
  return (
    <div className="block md:hidden">
      <div className="absolute left-[5%] top-[0%]">
        <StarDecoration width={26} height={26} />
      </div>
      <div className="absolute bottom-[35%] left-[10%]">
        <StarDecoration width={26} height={26} />
      </div>
      <div className="absolute bottom-[50%] right-[10%]">
        <StarDecoration width={43} height={43} />
      </div>
    </div>
  )
}
